// extracted by mini-css-extract-plugin
export var quantityInput = "_j8-0";